import { Controller } from "@hotwired/stimulus"
import { reactor } from "../lib/reactor"

const STORAGE_KEY = "hf-theme"
const DEFAULT_THEME = "dark"
const THEMES = ["light", "dark", "system"]
const THEME_COLOR_DARK = "#0b0f16"
const THEME_COLOR_LIGHT = "#eef0f4"

export default class extends Controller {
  static targets = ["option"]

  connect() {
    reactor(this)
    this.#media = window.matchMedia("(prefers-color-scheme: dark)")
    this.#media.addEventListener("change", this.#onSystemChange)
    document.addEventListener("theme:changed", this.#onThemeChanged)
    this.#highlight(this.#currentTheme())
    this.#syncThemeColor(this.#isDark(this.#currentTheme()))
  }

  disconnect() {
    this.#media.removeEventListener("change", this.#onSystemChange)
    document.removeEventListener("theme:changed", this.#onThemeChanged)
  }

  morph() {
    this.#highlight(this.#currentTheme())
  }

  select(event) {
    const theme = event.currentTarget.dataset.theme
    if (!THEMES.includes(theme)) return
    localStorage.setItem(STORAGE_KEY, theme)
    this.#apply(theme)
  }

  #media

  #currentTheme() {
    const stored = localStorage.getItem(STORAGE_KEY)
    return THEMES.includes(stored) ? stored : DEFAULT_THEME
  }

  #onSystemChange = () => {
    if (this.#currentTheme() === "system") this.#apply("system")
  }

  #isDark(theme) {
    return theme === "dark" || (theme === "system" && this.#media.matches)
  }

  #apply(theme) {
    const dark = this.#isDark(theme)
    const el = document.documentElement
    el.classList.toggle("dark", dark)
    el.classList.toggle("light", !dark)
    el.dataset.theme = theme
    this.#highlight(theme)
    this.#syncThemeColor(dark)
    document.dispatchEvent(new CustomEvent("theme:changed", { detail: { theme, dark } }))
  }

  #onThemeChanged = (event) => {
    this.#syncThemeColor(event.detail.dark)
  }

  #syncThemeColor(dark) {
    const meta = document.querySelector('meta[name="theme-color"]')
    if (meta) meta.setAttribute("content", dark ? THEME_COLOR_DARK : THEME_COLOR_LIGHT)
  }

  #highlight(theme) {
    this.optionTargets.forEach((el) => {
      el.setAttribute("aria-pressed", String(el.dataset.theme === theme))
    })
  }
}
